import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography, useTheme } from "@mui/material";
import { useState } from "react";
const handleImageError = (setImageError) => () => setImageError(true);
export const BrandLogo = ({ logoUrl, logoIsWhite, displayName, imageBaseURL, logoStyles, typographyVariant, typographyColor = "primary", }) => {
    const theme = useTheme();
    const [imageError, setImageError] = useState(false);
    const logoSrc = logoUrl
        ? `${imageBaseURL}img/brand_logos/${logoUrl}`
        : `${imageBaseURL}img/brand_logos/default_logo.png`; // Fallback image
    const backgroundColor = logoIsWhite ? theme.palette.primary.main : "#fff";
    const altText = displayName || "Brand Logo";
    return (_jsx(Box, { children: imageError ? (_jsx(Typography, Object.assign({ variant: typographyVariant, color: typographyColor }, { children: altText }))) : (_jsx("img", { style: Object.assign(Object.assign({}, logoStyles), { backgroundColor }), src: logoSrc, alt: altText, onError: handleImageError(setImageError) })) }));
};
